import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import OnTraccrButton from './buttons/OnTraccrButton';
import DisplayText from './text/DisplayText';
import colors from '../constants/Colors';
import noData from '../assets/images/noData.svg';
import { setMenu } from '../menu/state/menu.actions';
import Analytics from '../helpers/Analytics';
import { safeExtractFromObject } from '../helpers/helpers';

export default function OnTraccrEmpty({
  title = '',
  description = '',
  onAddNewClick = null,
  showOnlyTitle = false,
}) {
  const dispatch = useDispatch();
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));
  const hasRedesign = settings?.uxRedesignPt1;

  const selectedKeys = useSelector((state) => state.menu.items);
  const handleSetMenu = () => {
    Analytics.track('NUX/Open', { Source: 'No Data' });
    dispatch(setMenu(selectedKeys.concat(['getStarted'])));
  };

  let displayTitle = `Get started ${title ? `with ${title}` : 'here'}`;
  if (showOnlyTitle) {
    displayTitle = `You have no data here yet.`;
  }

  // Render different component based on redesign flag
  if (hasRedesign) {
    return (
      <Row style={{ width: '100%', height: '100%' }} justify="center" align="middle">
        <Row justify="center">
          <InboxOutlined
            style={{ fontSize: 100, color: colors.REDESIGN_PRIMARY_TEXT, marginBottom: 12 }}
          />
          <DisplayText
            title={displayTitle}
            style={{
              textAlign: 'center',
              fontSize: 20,
              fontFamily: 'open-sans, sans-serif',
              color: colors.REDESIGN_PRIMARY_TEXT,
              marginBottom: 12,
            }}
          />
          <DisplayText
            title={description || 'You have no data here yet.'}
            style={{
              textAlign: 'center',
              fontSize: 14,
              fontFamily: 'open-sans, sans-serif',
              color: colors.REDESIGN_SECONDARY_TEXT,
            }}
          />
          {
            onAddNewClick && (
              <OnTraccrButton
                title={`Start using ${title}`}
                type="primary"
                onClick={onAddNewClick}
              />
            )
          }
        </Row>
      </Row>
    );
  }

  // Original component for non-redesign
  return (
    <Row style={{ width: '100%', height: '100%' }} justify="center" align="middle">
      <Row justify="center">
        <img
          src={noData}
          alt="No Data"
          style={{
            width: 100,
            height: 100,
            marginBottom: 20,
          }}
        />
        <DisplayText
          title={(
            <div>
              You have no data here yet.<br />
              Need Help?
            </div>
          )}
          style={{
            textAlign: 'center',
            fontSize: 20,
            fontFamily: 'roboto-regular',
            color: colors.DARK_GRAY,
          }}
        />
        <OnTraccrButton
          title="Getting Started"
          type="cancel"
          onClick={handleSetMenu}
        />
      </Row>
    </Row>
  );
}

OnTraccrEmpty.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onAddNewClick: PropTypes.func,
  showOnlyTitle: PropTypes.bool,
};

OnTraccrEmpty.defaultProps = {
  title: '',
  description: '',
  onAddNewClick: null,
  showOnlyTitle: false,
};
